// Category
const Listcategory = () => import('@/views/campaign-management/category/index')
const Formcategory = () => import('@/views/campaign-management/category/form')

export default {
    path: 'category',
    redirect: '/category',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'category',
            component: Listcategory,
            meta: {
                link: 'category',
                breadcrumb: [
                    { title: 'Campaign Management', active: true },
                    { title: 'Category', active: true },
                ],
                pageTitle: 'Category'
            }
        },
        {
            path: 'add',
            name: 'addcategory',
            component: Formcategory,
            meta: {
                link: 'category',
                breadcrumb: [
                    { title: 'Campaign Management', active: true },
                    { title: 'Category', url: '/category' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Category'
            }
        },
        {
            path: 'edit/:id',
            name: 'editcategory',
            component: Formcategory,
            meta: {
                link: 'category',
                breadcrumb: [
                    { title: 'Campaign Management', active: true },
                    { title: 'Category', url: '/category' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Category'
            }
        },
    ]
}